const Visibility = Object.freeze({
  PUBLIC: 'Public',
  PRIVATE: 'Private'
});

export const getAttendeeVisibility = (
  meVisibility,
  defaultProfileVisibility
) => {
  let visibility = Visibility.PRIVATE;

  if (meVisibility) {
    visibility = meVisibility;
  } else {
    visibility = defaultProfileVisibility
      ? Visibility.PUBLIC
      : Visibility.PRIVATE;
  }

  return visibility;
};
